import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant';

import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle)
import 'vant/lib/index.css';
Vue.use(Vant);
import 'lib-flexible'
import "./assets/style/common.css"
import service from './api/request.js'
import 'babel-polyfill';
import Es6Promise from 'es6-promise'
Es6Promise.polyfill()
Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
